import sound from '../assets/audio/offline.mp3';

const audio = new Audio(sound);

export const playNotificationSound = () => {
  audio.currentTime = 0;
  audio.play().catch(() => {});
};
